import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAxiosInstance } from "../../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { getAdminProfile } from "../../../services/AdminService";
import AdminUpdateBio from "./AdminUpdateBio";
import AdminUpdatePassword from "./AdminUpdatePassword";
import AdminProfilePhoto from "./AdminProfilePhoto";

function AdminAccount() {
  const [bio, setBio] = useState("");
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await getAdminProfile(apiInstance, authUser?.user?.id);
        if (response) {
          setBio(response.bio);
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to load profile data",
          { position: "top-right" },
        );
      }
    };

    if (authUser?.user?.id) {
      getProfile();
    }
  }, [authUser, apiInstance]);

  return (
    <>
      <div className="p-4 bg-gray-100 h-screen overflow-auto pb-60 md:overflow-visible md:pb-0">
        <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
          <div className="w-full lg:w-2/4 xl:w-2/4">
            {/* Personal Info Start */}
            <div className="bg-white shadow-lg py-4 rounded-lg border-gray-300 hidden">
              <div className="w-full px-4">
                <h1 className="text-xl mb-4 uppercase">Personal Info</h1>
              </div>
            </div>
            {/* update bio*/}
            <AdminUpdateBio initialBio={bio} />
            {/* end update bio*/}
            {/* Update Password Start */}
            <AdminUpdatePassword />
          </div>
          <div className="w-full lg:w-2/4 xl:w-2/4">
            {/* Profile Photo Start */}
            <AdminProfilePhoto />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminAccount;
